import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import VueGtag from 'vue-gtag'
import Home from '../views/Home.vue'
import UserConsole from '../views/UserConsole.vue'
import NeoConsole from '../views/NeoConsole.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '*',
    component: Home
  },
  {
    path: '/console',
    component: UserConsole
  },
  {
    path: '/neo',
    component: NeoConsole
  }
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

Vue.use(VueGtag, {
  config: {id: 'UA-41950579-5'}
}, router);

export default router
